import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import CenterColumnContainer from 'compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer';
import BillerView from 'compid/shared/views/BillerView';
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import TableView, { TableRowView } from 'compid/shared/views/TableView';
import UIButton from 'compid/ui/UIButton';
import { Payment } from "model";
import React from "react";

/**
 * @function ProcessedPaymentView
 * @return {React.Component}
 * @exported true
 * @description The main component for ProcessedPaymentView.
 * ProcessedPaymentView is shown for payments that have already been processed in the ViewPaymentPage.
 */

export default function ProcessedPaymentView(props) {
  const { branding }= useModel();
  const navigate = useRoute();
  const payment = props.payment;
  // All confirmation numbers for payments will be the same for now.
  const confirmationNumber = payment.confirmationNumber ? payment.confirmationNumber : "TN2RH-1LNHX";
  const biller = payment.to;
  const isPaper = biller.paymentType === "paper";
  const isVirtualCard = biller.paymentType === "virtualCard";
  const fromAccount = payment.from;
  const paymentDateFormatted = payment.date.format(`M d`);
  const deliverDateFinePrint = `Your check maybe cashed, and the money withdrawn from your account, before, on, or after ${ paymentDateFormatted }.`
  const deliverDateFinePrintPaper = `Money was withdrawn from your account on ${ paymentDateFormatted }. The Payment was applied on ${ paymentDateFormatted }.`
  const deliverDateFinePrintElectronic = `Money was withdrawn from your account on [[date before Estimated Delivery]]. The Payment was applied on [[date before Estimated Delivery]].`
  const deliveryMethodMessage = isPaper ? "Check" : "Electronic";
  const paymentInquiry = () => navigate(`/paymentInquiryWorkflow/${payment.id}`);
  const done = () => navigate(-1);
  const withdrawnOnDate = Payment.getWithdrawOnDate(payment.date, payment.to.paymentType, branding);
  const withdrawnOnLabel = withdrawnOnDate.format("M d");
  const deliverByLabel = payment.date.format("M d");
  const hasRealTimeGoodFunds = Payment.hasRealTimeGoodFunds(payment.to.paymentType, branding);
   
  return(
    
        <div className="flex-container flex-vertical flex-width processed-payment-view">
          <div className="flex-height flex-container flex-vertical upper-content-container">
              {/* BillerView needs hook up - Has to comment it out as it caused issues on the page  */}
              <BillerView biller={ biller }
              paymentInfo={
                  <BillerPaymentView 
                      amount={ payment.amount }
                      status={ payment.status }
                      date={ payment.formatDate }
                      showAutopay={ payment.hasRelatedAutopay }
                      description={<>Last<span className="show-on-desktop payment">Payment</span><span className="show-on-mobile payment">pmt</span></>} />
              } 
            />
          </div>
          <div className="flex-height flex-width flex-container all-center">
            <CenterColumnContainer>
              <TableView>
                <TableRowView label="Confirmation" labelClass="semi-bold-text" data={ confirmationNumber } />
                
                { isPaper && <TableRowView label="Check number" labelClass="semi-bold-text" data={ "1234" } /> }
                
                <TableRowView label="Amount" labelClass="semi-bold-text" data={ payment.amount.format() } />
                <TableRowView label="Pay from" labelClass="semi-bold-text" data={ fromAccount.name + " " +  fromAccount.number } />
                { isPaper &&
                 !hasRealTimeGoodFunds && <>
                    <TableRowView label="Estimated delivery" labelClass="semi-bold-text" data={ payment.date.format('M d') } />
                    <TableRowView label="" data={ deliverDateFinePrint } dataClass="fine-print" />
                    <TableRowView label="" data={ deliverDateFinePrintPaper } dataClass="fine-print" />
                  </>
                }
                { !isPaper && <TableRowView label="Deliver by" labelClass="semi-bold-text" data={ deliverByLabel } /> }
                <TableRowView label="Withdraw on" labelClass="semi-bold-text" data={ withdrawnOnLabel } />
                <TableRowView label="Delivery method" labelClass="semi-bold-text" data={ deliveryMethodMessage } />
                
              </TableView>
              { isVirtualCard && 
              <div>{ `Money was withdrawn from your account on ${ paymentDateFormatted }.` }</div>
              }
              <ButtonContainer className="form-button-container">
                <UIButton className="secondary-button" onClick={ paymentInquiry }>Inquire about payment</UIButton>
                <UIButton className="primary-button" onClick={ done }>Done</UIButton>
              </ButtonContainer>
            </CenterColumnContainer>
          </div>
        </div>
  );
}